export class Station {
    public id: string;
    public name: string;
    public deviceId?: string;
    public deviceKind?: string;
    public enrolledAt?: string;
    public lastSeenAt?: string;

    constructor(
        id: string,
        name: string,
        deviceId?: string,
        deviceKind?: string,
        enrolledAt?: string,
        lastSeenAt?: string
    ) {
        this.id = id;
        this.name = name;
        this.deviceId = deviceId;
        this.deviceKind = deviceKind;
        this.enrolledAt = enrolledAt;
        this.lastSeenAt = lastSeenAt;
    }
}
